var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner",class:_vm.size},[_c('b-spinner',{attrs:{"variant":_vm.variant}}),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.caption)+"...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }